import script from "./OfUserList.vue?vue&type=script&setup=true&lang=js"
export * from "./OfUserList.vue?vue&type=script&setup=true&lang=js"

import "./OfUserList.vue?vue&type=style&index=0&id=11728689&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11728689"]])

export default __exports__